import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';
import { INVOCA } from '../constants';

const InvocaRuntime = (): JSX.Element => (
    <Script
        id="invoca"
        strategy={ScriptStrategy.postHydrate}
        dangerouslySetInnerHTML={{
            __html: `
                        (function (i, n, v, o) {
                          i.InvocaTagId = o;
                          var s = n.createElement('script');
                          s.type = 'text/javascript';
                          s.async = true;
                          s.src = v;
                          var fs = n.getElementsByTagName('script')[0];
                          fs.parentNode.insertBefore(s, fs);
                        })(window, document, location.origin + '/ivr/script.js', '${INVOCA.CLIENT_SIDE.INVOCA_NETWORK_ID}/${INVOCA.CLIENT_SIDE.INVOCA_TAG_ID}');
                      `,
        }}
    />
);

export default InvocaRuntime;
